export default {
  aboutPage: {
    seoTitle: 'About Geofleet — Delivery Management Software with AI',
    seoDescription:
      'Geofleet builds delivery management software with an AI Copilot, used by 100+ customers in 20+ countries. SOC 2 and ISO 27001 certified, with public pricing from $49 a month for 3 drivers.',
    badge: 'About Geofleet',
    title: 'We build the command centre',
    titleHighlight: 'for delivery teams',
    lead:
      'Geofleet is delivery management software for teams that run their own fleets. Dispatchers plan and track every stop in one command centre, drivers work from one app, and customers follow a live tracking link. An AI Copilot handles the busywork, within the permissions you set.',
    stats: [
      { value: '100+', label: 'Customers' },
      { value: '20+', label: 'Countries' },
      { value: '50+', label: 'Integrations' },
      { value: '99.99%', label: 'Uptime' },
    ],
    heroImageAlt: 'The Geofleet command centre with a live delivery map, KPIs and today’s orders',

    missionKicker: 'Why we exist',
    missionTitle: 'Most deliveries are still run from chats and spreadsheets',
    missionBody: [
      'In most delivery operations, the plan lives in a spreadsheet, dispatch happens in group chats, and customers call to ask where their order is. Every late driver becomes a round of phone calls.',
      'We started Geofleet to put that work in one place. Orders come in, routes are planned, drivers are dispatched, customers are kept informed and every delivery ends with proof. When something slips, the command centre shows it first and Copilot suggests the fix.',
    ],
    missionQuote: 'Our goal: every delivery team gets the tools large carriers have, without an enterprise sales cycle.',

    principlesKicker: 'How we work',
    principlesTitle: 'What we believe',
    principles: [
      {
        title: 'The price is on the page',
        body: 'Public pricing, starting at $49 a month for 3 drivers. You should know what it costs before you talk to anyone.',
      },
      {
        title: 'AI with guardrails',
        body: 'Copilot and our AI agents act only within each user’s role. They propose, people confirm, and every change is logged.',
      },
      {
        title: 'Built on live data',
        body: 'Every answer and suggestion comes from what is happening on the road right now, not from generic AI text.',
      },
      {
        title: 'Security is not optional',
        body: 'Geofleet is SOC 2 and ISO 27001 certified, with data encrypted at rest and in transit and role-based access throughout.',
      },
    ],

    productKicker: 'What we build',
    productTitle: 'One platform, from order to proof of delivery',
    products: [
      { title: 'Command centre', body: 'Live map, prioritized exceptions and every order in one view.', href: '/how-it-works' },
      { title: 'Copilot and AI agents', body: 'Ask in plain language, automate dispatch and resolve exceptions.', href: '/features/ai-agents' },
      { title: 'Route planner', body: 'Optimized routes with time windows, capacity and traffic.', href: '/features/route-planner' },
      { title: 'Driver app', body: 'Navigation, proof of delivery and attendance, even offline.', href: '/features/driver-app' },
      { title: 'Branded tracking', body: 'A live tracking link customers open in any browser.', href: '/features/branded-tracking' },
      { title: 'Reports and analytics', body: 'On-time rate, cost per drop and driver scorecards.', href: '/features/reports-analytics' },
    ],

    industriesKicker: 'Who we serve',
    industriesTitle: 'Teams that deliver every day',
    industriesBody:
      'Restaurants, pharmacies, couriers, grocers, retailers, distributors and field service teams use Geofleet in 20+ countries, from 10-driver fleets to multi-hub operations.',
    industriesCta: 'See all industries',

    trustKicker: 'Trust and security',
    trustTitle: 'Built to be relied on',
    trustItems: [
      { title: 'SOC 2', body: 'Independently audited security controls.' },
      { title: 'ISO 27001', body: 'Certified information security management.' },
      { title: '99.99% uptime', body: 'A platform your dispatch can run on all day.' },
      { title: 'Encryption and access control', body: 'Data encrypted at rest and in transit, with role-based permissions and audit logs.' },
    ],
    trustCta: 'Ask for our security documentation',

    connectKicker: 'Work with us',
    connectTitle: 'Get in touch',
    connectCards: [
      { title: 'Try Geofleet', body: 'Start on Geofleet Lite with your own orders, from $49 a month for 3 drivers.', cta: 'Get started' },
      { title: 'Talk to our team', body: 'Book a demo and we’ll walk through your delivery workflow.', cta: 'Book a demo' },
      { title: 'Become a partner', body: 'Resell or integrate Geofleet, with a self-service partner portal.', cta: 'Partner program' },
    ],
    contactLine: 'General questions:',
  },
};
